export default __webpack_public_path__ + "static/media/大都会_white.c3ba8b45.jpg";